import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Router, ActivatedRoute } from '@angular/router';
import { livetrackingModel } from '../../model'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TravelMarker, TravelMarkerOptions, TravelData, TravelEvents, EventType } from 'travel-marker';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { ExcelService } from '../../exceldownloader';

@Component({
    selector: 'app-liveareatracking',
    template: require('./liveareatracking.component.html'),
    styles: []
})

export class LiveAreaTrackingComponent implements OnInit, OnDestroy {
    private noRowsTemplate;
    private loadingTemplate;
    trackData: livetrackingModel = new livetrackingModel();
    expDetails: any;
    expEmpDetails: any = [];
    expDetailsEmpWise: any = [];
    private columnDefs;
    private rowHeight;
    private columnDefsPopup;
    private expDetailsPopup;
    private columnDefsDetails;
    api: any;
    api1: any;
    api2: any;
    empId: any;
    columnApi: any;
    columnApi1: any;
    columnApi2: any;
    defaultColDefine;
    private gridColumnApi;
    private gridColumnApi1;
    private gridColumnApi2;
    stateData: any = [];
    empData: any = [];
    status: boolean = false;
    static parameters = [ApiService, Router, ActivatedRoute, HttpClient, ExcelService]
    firstDate: string;
    lastDate: string;
    ManagerList:any;
    token:any;
    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, private http: HttpClient, private ExcelService: ExcelService) {
        let parent = this;
        this.apiService = apiService
        // this.loadingTemplate =
        //   `<span class="ag-overlay-loading-center">data is loading...</span>`;
        // this.noRowsTemplate =
        //   `"<span">no rows to show</span>"`;
        this.columnDefs = [
            // { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'DCR Date', field: "PlanDate" },
            { headerName: 'Employee', field: "Client_LegalName", pinned: 'left' },
            { headerName: 'Emp code', field: "Client_Code" },
            { headerName: 'Manager', field: "Manager" },
            { headerName: 'State', field: "StateName" },
            { headerName: 'Head Qtr', field: "HQName" },
            { headerName: 'Designation', field: "ClientTypeDesc", suppressFilter: true },
            // { headerName: 'Division', field: "DivisionName" },
            { headerName: 'Day Plan Date', field: "DayPlanDate" },
            { headerName: 'Working Type', field: "WorkingOption" },
            { headerName: 'Work With', field: "WorkingWith" },
            { headerName: 'Route', field: "RouteName" },
            { headerName: 'DA Type', field: "DAType", suppressFilter: true },
            { headerName: 'Working Area', field: "Working_Area" },
            { headerName: 'Submit Area', field: "LeaveAddress" },
            { headerName: 'First Call', field: "FirstCall" },
            { headerName: 'Last Call', field: "LastCall" },
            { headerName: 'WH', field: "WH" },
            // { headerName: 'GPS', field: "" },
            { headerName: 'GPS-KMS', field: "GPSKM" },
            // { headerName: 'doctor', field: "DaLocalPlus" },
            // { headerName: 'Patient', field: "DaEx" },
            { headerName: 'Retailer POB', field: "RPOB" },
            { headerName: 'Stk. POB', field: "SPOB" },
            { headerName: 'Non Listed POB', field: "NonListedPOB" },
            { headerName: 'Leave Time', field: "LeaveTime" },
            { headerName: 'Submit Date', field: "submitDate" },
            { headerName: 'Master Retailer', field: "taggedRetailer" },
            { headerName: 'Master KM', field: "KM" },
            { headerName: 'Productive Call', field: "ProductiveCall" },
            { headerName: 'Retailer Call', field: "RetailerCall" },
            { headerName: 'Stk Call', field: "StockistCall" },
            { headerName: 'Non Listed Call', field: "NonListedCall" },
            {                
                headerName: '', field: "Action", width: 130, pinned: 'right', cellRenderer: function (params) {                    
                    var eDiv = document.createElement('div');
                    if(params.data.Client_Code){
                        eDiv.innerHTML = `
                        <div class="grid_actions">
                            <span class="viewBtn grid_actions_item mr-1" ><button class="btn btn-primary">Map</button></span>
                            <span class="detailBtn grid_actions_item" data-target="#EmployeeTrackingRecord" data-toggle="modal"><button class="btn btn-info">Detail</button></span>
                        </div>
                        `;
                        var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
                        viewButton.addEventListener('click', function () {
                            parent.tracking(params);
                        });
                        var detailButton = eDiv.querySelectorAll('.detailBtn')[0];
                        detailButton.addEventListener('click', function () {
                            parent.getEmpDetailsData(params.data);
                        });
                    }
                    return eDiv;
                }
            }
        ];

        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
        this.columnDefsPopup = [
            { headerName: 'S.No.', valueGetter: params => { return params.data.Type? params.node.rowIndex + 1: "" }, width: 80 },
            { headerName: 'Time', field: 'CallTime', width: 80 },
            { headerName: 'Type', field: 'Type', width: 100 },
            { headerName: 'Name', field: 'Name', width: 250 },
            { headerName: 'Area', field: 'Area' },
            { headerName: 'Mobile', field: 'mobile' },
            // { headerName: 'Code', field: 'code'},
            { headerName: 'Work With 1', field: 'work_1' },
            { headerName: 'Work With 2', field: 'work_2' },
            { headerName: 'Reg. Address', field: 'reg_add', width: 350 },
            { headerName: 'Working Address', field: 'work_aad', width: 350 },
            { headerName: '	Registered vs Called Diff KM', field: 'called_diff' },
            { headerName: 'Lat Long', field: 'latlng' },
            { headerName: '	Battery Percent', field: 'battery', cellStyle: { 'textAlign': "right" } },
            { headerName: 'Remark', field: 'remark' },
            { headerName: 'POB', field: 'POB', cellStyle: { 'textAlign': "right" } },
        ];

        this.columnDefsDetails = [
            { headerName: 'DCR Date', field: "PlanDate" },
            { headerName: 'Employee', field: "Client_LegalName", pinned: 'left' },
            { headerName: 'Emp code', field: "Client_Code" },
            { headerName: 'Manager', field: "Manager" },
            { headerName: 'State', field: "StateName" },
            { headerName: 'Head Qtr', field: "HQName" },
            { headerName: 'Designation', field: "ClientTypeDesc", suppressFilter: true },
            { headerName: 'Day Plan Date', field: "DayPlanDate" },
            { headerName: 'Working Type', field: "WorkingOption" },
            { headerName: 'Work With', field: "WorkingWith" },
            { headerName: 'Route', field: "RouteName" },
            { headerName: 'DA Type', field: "DAType", suppressFilter: true },
            { headerName: 'Working Area', field: "Working_Area" },
            { headerName: 'Submit Area', field: "LeaveAddress" },
            { headerName: 'First Call', field: "FirstCall" },
            { headerName: 'Last Call', field: "LastCall" },
            { headerName: 'WH', field: "WH" },
            { headerName: 'GPS-KMS', field: "GPSKM" },
            { headerName: 'Retailer POB', field: "RPOB" },
            { headerName: 'Stk. POB', field: "SPOB" },
            { headerName: 'Non Listed POB', field: "NonListedPOB" },
            { headerName: 'Leave Time', field: "LeaveTime" },
            { headerName: 'Submit Date', field: "submitDate" },
            { headerName: 'Master Retailer', field: "taggedRetailer" },
            { headerName: 'Master KM', field: "KM" }, 
            { headerName: 'Productive Call', field: "ProductiveCall" },
            { headerName: 'Retailer Call', field: "RetailerCall" },
            { headerName: 'Stk Call', field: "StockistCall" },
            { headerName: 'Non Listed Call', field: "NonListedCall" },
            { headerName: 'S.No.', field: 'Sr_No', width: 80 },
            { headerName: 'Time', field: 'CallTime'},
            { headerName: 'Type', field: 'Type'},
            { headerName: 'Name', field: 'Name'},
            { headerName: 'Area', field: 'Area'},
            { headerName: 'Mobile', field: 'mobile' },
            { headerName: 'Work With 1', field: 'work_1' },
            { headerName: 'Work With 2', field: 'work_2' },
            { headerName: 'Reg. Address', field: 'reg_add'},
            { headerName: 'Working Address', field: 'work_aad'},
            { headerName: 'Registered vs Called Diff KM', field: 'called_diff'},
            { headerName: 'Lat Long', field: 'latlng' },
            { headerName: 'Battery Percent', field: 'battery', cellStyle: { 'textAlign': "right" } },
            { headerName: 'Remark', field: 'remark' },
            { headerName: 'POB', field: 'POB', cellStyle: { 'textAlign': "right" } },
        ];
    }

    zoom: number = 15;
    value: any;
    // initial center position for the map
    lat: number;
    lng: number;
    id: number;
    map: any;
    line: any;
    directionsService: any;
    marker: TravelMarker = null;
    locationData: any = [];
    LiveLatLongData: any = [];
    busy: Subscription;
    
    // speedMultiplier to control animation speed
    speedMultiplier = 1;
    trackForm = new FormGroup({
        fromDate: new FormControl(''),
        toDate: new FormControl(''),
        employee: new FormControl('', [Validators.required]),
        division: new FormControl('', [Validators.required]),
        zone: new FormControl('', [Validators.required]),
        state: new FormControl('', [Validators.required]),
        staffType: new FormControl('', [Validators.required]),
        employeeCode: new FormControl('', [Validators.required]),
        workingType: new FormControl('', [Validators.required]),
        ManagerID: new FormControl('', [Validators.required]),
    });

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        console.log('firstDate ', this.firstDate, this.lastDate);
        this.trackForm.controls['fromDate'].setValue(
            this.firstDate
        );
        this.trackForm.controls['toDate'].setValue(
            this.lastDate
        );
        this.trackData.employee = "0";
        this.trackData.division = "0";
        this.trackData.zone = "0";
        this.trackData.state = "0";
        this.trackData.staffType = "0";
        this.trackData.workingType = "0";
        this.trackData.ManagerID="0";
       
        console.log('this.firstdate', this.firstDate);
        console.log('this.lastDate', this.lastDate);
        $('#filter-option').trigger('click');
        var totalRow = { 
            "Client_LegalName": "Total: 0" ,
            "SPOB": (0).toFixed(2),
            "RPOB": (0).toFixed(2),
            "StockistCall": 0, 
            "RetailerCall": 0
        };
        setTimeout(()=>{
            this.api.setPinnedBottomRowData([totalRow])
        }, 300);
        this.getEmployee();
        this.getState();
        this.getManagerDetails();
    }

    ngOnDestroy() {
        this.status = false;
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
        })
    }
    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateData = res.data;
        })
    }

    getEmpDetails() {
        var parent = this;
        //this.api.showLoadingOverlay();
        // console.log('form value', this.trackForm.value);
        console.log(this.token.id);
        this.trackData = this.trackForm.value;
        this.trackData.LoginId = this.token.id;
        this.trackData.flag = 'H';
        console.log('form value', this.trackData);
        this.busy = this.apiService.getChemistEmployeeDetails(this.trackData).subscribe((res: any) => {
            this.expDetails = res.employee;
            //this.api.showNoRowsOverlay();
            var SPOB = this.expDetails.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.SPOB)); }, 0);
            var RPOB = this.expDetails.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.RPOB)); }, 0);
            var StockistCall = this.expDetails.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.StockistCall)); }, 0);
            var RetailerCall = this.expDetails.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.RetailerCall)); }, 0);
            var totalRow = {
                "Client_LegalName": "Total: " + this.expDetails.length ,
                "SPOB": (SPOB).toFixed(2),
                "RPOB": (RPOB).toFixed(2),
                "StockistCall": StockistCall, 
                "RetailerCall": RetailerCall
            };
            setTimeout(()=>{
                this.api.setPinnedBottomRowData([totalRow])
            }, 300);
            console.log('type of expDEtails', typeof this.expDetails, this.expDetails);
            //console.log('dataaa', this.expDetails);
        })
    }

    getEmpDetailsData(data) {
      //  console.log("details data", data)
        var Data = Object.assign({}, this.trackData);
        Data.employee = data.Client_Code
        Data.fromDate = data.PlanDate
        Data.toDate = data.PlanDate
        Data.flag = 'D';
        // Data.LoginId = data.LoginId; 
        this.expDetailsEmpWise = [];
        //this.api1.showLoadingOverlay();
        var parent = this;
        this.busy = this.apiService.getChemistEmployeeDetails(Data).subscribe((res: any) => {
            this.expDetailsEmpWise = res.employee;
            console.log('dataaaaaaaaaaaa', this.expDetailsEmpWise);
            var pobValue = this.expDetailsEmpWise.reduce(function(acc, sum){ return (acc + parent.f_ChkNum(sum.POB)); }, 0);
            var totalRow = { 
                POB: pobValue.toFixed(2),
                Name: "Total: " + this.expDetailsEmpWise.length
            };
            setTimeout(()=>{
                this.api1.setPinnedBottomRowData([totalRow]);
            }, 300);
        })
    }

    onGridReady = (params) => {
        this.api = params.api;
        //console.log('api', this.api);
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onGridReady1 = (params) => {
        this.api1 = params.api;
        this.gridColumnApi1 = params.columnApi;
        //this.api1.showNoRowsOverlay();
    }

    onGridReady2 = (params) => {
        this.api2 = params.api;
        console.log('api2', this.api2);
        this.gridColumnApi2 = params.columnApi;
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'TrackingData' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    // getLiveLatLong()
    // {
    //   this.apiService.getlivelatlong(this.empId).subscribe((res: any) => {
    //     console.log('get live lat long response', res);
    //     // debugger
    //     this.locationData = res.data;
    //   })
    // }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    tracking(item) {
        console.log("jtiem", item.data) // //this.router.navigate(['home/maptracking'],{ queryParams:{id:item.employee_code} }); // // this.router.navigate([]).then(result => { window.open('home/maptracking' + '/' + item.employee_code, '_blank'); }); 
        this.empId = item.data.Client_Code;

        const url = this.router.serializeUrl(this.router.createUrlTree(['/maptrackingtracking'], { queryParams: { id: item.data.Client_Code, date: item.data.PlanDate } })); window.open(url, '_blank');
    }

    eventHandlerlivetracking() {    
        this.status = true;
        this.getEmpDetails();
    }

    onBtnExportEmployeeWithDetails() {
        var Data = Object.assign({}, this.trackData);
        Data.employee = "0";
        Data.flag = 'D';
        this.busy = this.apiService.getChemistEmployeeDetails(Data).subscribe((res: any) => {
            let Details = res.employee;
            console.log('this.expDetails:', this.expDetails);
            console.log('Details:', Details);
            this.expEmpDetails = [];
            this.expDetails.forEach(elem => {
                this.expEmpDetails.push(elem);
                let DetailsList = Details.filter(item => {
                    return item.EmpId == elem.EmpId && item.PlanDate == elem.PlanDate
                });
                let Sno = 0;                
                DetailsList.forEach(element => {
                    Sno = Sno + 1;
                    this.expEmpDetails.push({Sr_No: Sno, CallTime: element.CallTime, Type: element.Type, Name: element.Name, Area: element.Area, mobile: element.mobile, code: element.code, work_1: element.work_1, work_2: element.work_2, reg_add: element.reg_add, work_aad: element.work_aad, called_diff: element.called_diff, latlng: element.latlng, battery: element.battery, remark: element.remark, POB: element.POB});
                });
            });
            console.log('this.expEmpDetails after merge:', this.expEmpDetails);
            // this.ExcelService.exportAsExcelFile(this.expEmpDetails, 'Employee Details');
            setTimeout(() => {
                this.api2.exportDataAsCsv({ fileName: 'Employee Details' });
            }, 500);
        })
    }
}
